import {Component} from '@angular/core';
import {AsyncPipe, DatePipe} from "@angular/common";
import {
    DxDateBoxComponent, DxSelectBoxComponent, DxTextAreaComponent, DxValidatorComponent
} from "devextreme-angular";
import {DxiValidationRuleComponent} from "devextreme-angular/ui/nested";
import EnumUtils from "../../../../../shared/enum-utils";
import {
    AccessType,
    ChangeLieuDayStatusCommand,
    CreateLieuDayCommand,
    EmployeeDto,
    LieuDayGridViewDto,
    LieuDaySlotType, PermissionType,
    TimeOffStatus
} from "@services";
import {TimeOffRequestModalComponent} from "../../time-off-request-modal/time-off-request-modal.component";
import TimeOffPopupComponent from "../../time-off-popup.component";
import {PicturedItemSelectBoxComponent} from "../../../../../components";

@Component({
    selector: 'app-lieu-day-popup',
    imports: [
        AsyncPipe,
        DxSelectBoxComponent,
        DxiValidationRuleComponent,
        DxDateBoxComponent,
        DatePipe,
        TimeOffRequestModalComponent,
        PicturedItemSelectBoxComponent,
        DxTextAreaComponent,
        DxValidatorComponent
    ],
    templateUrl: './lieu-day-popup.component.html'
})
export class LieuDayPopupComponent extends TimeOffPopupComponent<LieuDayGridViewDto> {
    typeOfRequests = EnumUtils.getEnumOptions(LieuDaySlotType);
    lieuDaysAvailable?: number;
    nextAvailableLieuDay?: string;
    LieuDaySlotType = LieuDaySlotType;
    protected readonly TimeOffStatus = TimeOffStatus;

    onSave() {
        let createLieuDayCommand = new CreateLieuDayCommand({
            userId: this.formData.employee.id,
            type: this.formData.type,
            requestedDate: this.formData.requestedDate,
            description: this.formData.description
        });

        this.timeOffClient.createLieuDay(createLieuDayCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    };

    async ngOnInit(): Promise<void> {
        this.employeeBalance.subscribe(balance => {
            this.lieuDaysAvailable = balance.lieuDaysAvailable;
            this.nextAvailableLieuDay = balance.nextAvailableLieuDay;
        })

        return super.ngOnInit();
    }

    async loadData() {
        if (this.request) {
            this.formData = new LieuDayGridViewDto();
            this.formData.init(this.request);
        } else {
            this.formData = new LieuDayGridViewDto();
            this.formData.init({
                requestedDate: new Date(),
                employee: this.canShowInSelectBox ? new EmployeeDto({id: this.auth.userId}) : new EmployeeDto(),
                expireDate: this.calcExpireDate(new Date())
            });
        }
        this.employeeId.next(this.formData.employee.id);
    }

    calcExpireDate(date: Date) {
        return new Date(date.getFullYear() + 1, date.getMonth(), date.getDate());
    }

    async onDateChanged(event: any) {
        this.formData.expireDate = event.value ? this.calcExpireDate(event.value) : null;
    }

    changeStatus(status: TimeOffStatus) {
        let changeStatusCommand = new ChangeLieuDayStatusCommand({
            userId: this.formData.employee.id,
            status: status,
            slotId: this.formData.id
        });

        this.timeOffClient.changeLieuDayStatus(changeStatusCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    }

    protected get lieuDayToBeTaken() {
        return this.formData.takenBankSlotDate ?? this.nextAvailableLieuDay;
    }

    protected override get canApprove(): boolean {
        return super.canApprove && this.auth.checkPermission(PermissionType.LieuDayRequests, AccessType.Manage);
    };

    protected override get canDecline(): boolean {
        return super.canDecline && this.auth.checkPermission(PermissionType.LieuDayRequests, AccessType.Manage);
    };

    protected get canEditEmployee(): boolean{
        return super.canEditEmployee && this.auth.checkPermission(PermissionType.LieuDayRequests, AccessType.Manage);
    }
}

